import { createBrowserRouter } from "react-router-dom";
import AppLayout from "./App"; // wrapper with ToastNotification
import ProtectedRoute from "./shared/components/ProtectedRoute";

import Home from "./pages/home/Home";
import Reports from "./pages/reports/Reports";
import CreateSegment from "./pages/createSegment/CreateSegment";
import Segments from "./pages/segments/Segments";
import ViewAllAttributes from "./pages/home/ViewAllAttributes";
import Campaigns from "./pages/campaigns/Campaigns";
import CreateCampaign from "./pages/createCampaigns/CreateCampaigns";
import SummaryCampaign from "./pages/createCampaigns/SummaryCampaign";
import SegmentSummary from "./pages/segmentSummary/SegmentSummary";
import Login from "./pages/login";
import Destinations from "./pages/destinations/Destinations";
import CreateDestination from "./pages/createDestinations/CreateDestinations";

const router = createBrowserRouter([
  {
    path: "/login",
    element: <Login />,
  },
  {
    element: <ProtectedRoute />, // wrapper for all protected routes
    children: [
      {
        element: <AppLayout />, // AppLayout manages ToastNotification + context
        children: [
          { path: "/", element: <Home /> },
          { path: "/reports", element: <Reports /> },
          { path: "/create/segment", element: <CreateSegment /> },
          { path: "/segments", element: <Segments /> },
          { path: "/view-all-attributes", element: <ViewAllAttributes /> },
          { path: "/campaigns", element: <Campaigns /> },
          { path: "/create/campaigns", element: <CreateCampaign /> },
          { path: "/campaign/:campaignId", element: <SummaryCampaign /> },
          { path: "/segments/:segmentId", element: <SegmentSummary /> },
          { path: "/destinations", element: <Destinations /> },
          { path: "/create/destination", element: <CreateDestination /> },
        ],
      },
    ],
  },
]);

export default router;
